import { render, staticRenderFns } from "./VehicleMonthlyConsumptionChart.vue?vue&type=template&id=28654b53&scoped=true"
import script from "./VehicleMonthlyConsumptionChart.vue?vue&type=script&lang=ts"
export * from "./VehicleMonthlyConsumptionChart.vue?vue&type=script&lang=ts"
import style0 from "./VehicleMonthlyConsumptionChart.vue?vue&type=style&index=0&id=28654b53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28654b53",
  null
  
)

export default component.exports